export class PassengerConstant {
    static PASSENGER_INFANT: string = 'INFANT_NO_SEAT-ONE';
  }